<template>
  <div class="container-qrcode bg-dark">
    <qrcode-stream
        :camera="camera"
        :paused="paused"
        @decode="onDecode"
        @init="handleInit"
        class="mirrored">
      <div class="overlay" v-if="overlay">{{overlay}}</div>
      <div class="text-right p-2">
        <button class="btn btn-light px-3" @click="toggleCam"><i class="fa fa-refresh"></i></button>
      </div>
    </qrcode-stream>
    <svg xmlns="http://www.w3.org/2000/svg" class="qrcode-svg" data-name="Layer 1" viewBox="0 0 24 24" fill="#fff"><path d="M4 11h7V4H4zm16-7h-7v7h7zM4 20h7v-7H4zm-1 2h4v2H3c-1.654 0-3-1.346-3-3v-4h2v4c0 .551.449 1 1 1m19-5h2v4c0 1.654-1.346 3-3 3h-4v-2h4c.551 0 1-.449 1-1zm2-14v4h-2V3c0-.551-.449-1-1-1h-4V0h4c1.654 0 3 1.346 3 3M2 7H0V3c0-1.654 1.346-3 3-3h4v2H3c-.551 0-1 .449-1 1zm11 10h3v3h-3zm4-1v-3h3v3zm-4-3h3v3h-3z"/></svg>
  </div>
</template>

<script>
export default {
  name: "QrReader",
  props: ['overlay'],
  data() {
    return {
      qrCode: '',
      camera: localStorage.getItem('camera') || 'front',
      paused: false
    };
  },

  methods: {
    onDecode(result) {
      this.qrCode = result;
      this.paused = true;
      const comanda = (result || '').replace(/\D/g, "");

      if (comanda) {
        this.$emit('avancar', parseInt(comanda));
      }

      setTimeout(() => {
        this.paused = false;
      }, 2000);
    },

    async handleInit(promise) {
      try {
        await promise;

      } catch (error) {
        console.error(error);
        this.$swal("Erro ao acessar a câmera.");
      }
    },

    toggleCam() {
      const cam = this.camera === 'auto' ? 'front' : 'auto';
      localStorage.setItem('camera', cam)
      this.camera = cam;
    }
  }
};
</script>

<style scoped>
.container-qrcode {
  border: 4px solid #FFFFFF;
  border-radius: 12px;
  overflow: hidden;
  height: calc(100vh - 250px);
  position: relative;
}

.container-qrcode .qrcode-svg {
  height: 50%;
  position: absolute;
  transform: translate(-50%,-50%);
  top: 50%;
  left: 50%;
}

.overlay {
  position: absolute; left: 0; right: 0; bottom: 0;
  padding: 12px 16px; text-align: center;
  background: rgba(0,0,0,.55); color: #fff; font-size: 14px;
}

.mirrored >>> video {
  transform: scaleX(-1);
}
</style>